// Pure helpers for the "Get inspiration" restaurant search (InspirationSheet).
// Kept separate from panels.js so the query-building/hotel-dedup logic is
// unit-testable without rendering the sheet.

// Distinct hotel names booked for this trip, in stay order — sourced from
// bookings.accommodation_details.legs (see utils/scanDetails.js applyHotelScan).
// Not matched to a specific city/leg; multi-city trips just get one chip per
// stay regardless of which leg it belongs to.
export function uniqueHotelNames(bookings) {
  const legs = bookings?.accommodation_details?.legs || [];
  const seen = new Set();
  const names = [];
  for (const leg of legs) {
    const name = (leg.hotelName || '').trim();
    if (name && !seen.has(name)) { seen.add(name); names.push(name); }
  }
  return names;
}

// Builds the plain-language query sent to /api/tp/ai/restaurants. Exactly one
// of city/hotelName is expected to be set by the caller.
export function buildRestaurantQuery({ city, hotelName } = {}) {
  if (hotelName && hotelName.trim()) return `restaurants near ${hotelName.trim()}`;
  if (city && city.trim()) return `restaurants in ${city.trim()}`;
  return '';
}
